import { useEffect, useState } from 'react';

type MountPhase = 'opening' | 'idle' | 'minimizing' | 'minimized' | 'restoring';

const PHASE_MS: Partial<Record<MountPhase, number>> = {
  opening: 240,
  restoring: 200,
  minimizing: 180,
};

/** 열기·최소화·복원 애니메이션 단계를 hidden 변화에 맞춰 진행시킨다. */
export function useMountPhase(hidden: boolean): MountPhase {
  const [lifecycle, setLifecycle] = useState<{ hidden: boolean; phase: MountPhase }>({
    hidden,
    phase: hidden ? 'minimized' : 'opening',
  });
  if (lifecycle.hidden !== hidden) {
    setLifecycle({ hidden, phase: hidden ? 'minimizing' : 'restoring' });
  }
  const mountPhase = lifecycle.phase;

  useEffect(() => {
    const duration = PHASE_MS[mountPhase];
    if (duration === undefined) return;
    const id = setTimeout(
      () => setLifecycle((prev) => ({ ...prev, phase: prev.hidden ? 'minimized' : 'idle' })),
      duration
    );
    return () => clearTimeout(id);
  }, [mountPhase]);

  return mountPhase;
}
